import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';

@Injectable({
  providedIn: 'root'
})
export class Ogp6Service {

  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }

  getReportesAtendidos() {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/ogp-6/atendidas', {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/ogp-6/atendidas')
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  
  getReportesPendientes() {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/ogp-6/pendientes', {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/ogp-6/pendientes')
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }


  getNoProcesadas() {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/ogp-6/no-procesadas', {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/ogp-6/no-procesadas')
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
  getReporteById(id){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/ogp-6/get/'+id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/ogp-6/get/'+id)
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  updateProcede(id,form){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.put(CONFIG.API + '/api/ogp-6/procede/'+id, form, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.put(CONFIG.API + '/api/ogp-6/procede/'+id, form)
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  
  actualizar(id,form){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.put(CONFIG.API + '/api/ogp-6/'+id, form, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.put(CONFIG.API + '/api/ogp-6/'+id, form)
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  compartir(id){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/ogp-6/share/'+id,{}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/ogp-6/share/'+id, {})
          .subscribe((persona: any) => {
            resolve(persona)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
